import { CodeBook } from "@king-ict/eupisi-ui/models";
import { codeBookToSelectData } from "@king-ict/eupisi-ui/utils";

import type { IOibPersonData } from "../../oib";
import type { SchoolCandidate } from "../../../models/SchoolCandidate";

export function buildOibPersonDataFromSchoolCandidate(params: {
  schoolCandidate: SchoolCandidate;
  alternativeCodeTypes: CodeBook[] | undefined;
  alternativeCodeReasons: CodeBook[] | undefined;
  handleFieldChange: (
    field: keyof SchoolCandidate,
    value: string | number | boolean | Date | undefined,
    options?: {
      parseAsNumber?: boolean;
      allowEmpty?: boolean;
      customMapping?: (value: any) => any;
    }
  ) => void;
}): IOibPersonData {
  const {
    schoolCandidate,
    alternativeCodeTypes,
    alternativeCodeReasons,
    handleFieldChange,
  } = params;

  return {
    alternativeCodeValue: schoolCandidate.alternativeCode ?? "",
    onAlternativeCodeChange: (value: string) =>
      handleFieldChange("alternativeCode", value),
    alternativeTypeId: schoolCandidate.schoolCandidateAlternativeCodeTypeId,
    alternativeTypeOptions: codeBookToSelectData(alternativeCodeTypes),
    onAlternativeTypeChange: (value: string) =>
      handleFieldChange("schoolCandidateAlternativeCodeTypeId", value, {
        parseAsNumber: true,
        allowEmpty: true,
        customMapping: (mappedValue) =>
          Number.isNaN(Number.parseInt(mappedValue))
            ? null
            : Number.parseInt(mappedValue),
      }),
    alternativeReasonId: schoolCandidate.schoolCandidateAlternativeCodeReasonId,
    alternativeReasonOptions: codeBookToSelectData(alternativeCodeReasons),
    onAlternativeReasonChange: (value: string) =>
      handleFieldChange("schoolCandidateAlternativeCodeReasonId", value, {
        parseAsNumber: true,
        allowEmpty: true,
        customMapping: (mappedValue) =>
          Number.isNaN(Number.parseInt(mappedValue))
            ? null
            : Number.parseInt(mappedValue),
      }),
    lastNameValue: schoolCandidate.lastName,
    onLastNameChange: (value: string) =>
      handleFieldChange("lastName", value),
    firstNameValue: schoolCandidate.firstName,
    onFirstNameChange: (value: string) =>
      handleFieldChange("firstName", value),
  };
}
